import "./utils/useTranslation.js";
import React from "react";
import { BrowserRouter, useLocation, Navigate } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.rtl.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
import "../src/style/scss/main.scss";
import "../src/customStyle.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/fonts/feather/css/iconfont.css";
import { createRoot } from "react-dom/client";
import "./i18n";
import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import langData from "./utils/lang.json";
import "bootstrap/dist/js/bootstrap.bundle.min";

const rootElement = document.getElementById("root");

// global translator helper
window.translate = (key) => {
  const lang = localStorage.getItem("lang") || "en";
  return langData?.[key]?.[lang] || langData?.[key]?.["en"] || key;
};

// --- helpers ---
function isTokenValid() {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const base64 = token.split(".")[1]?.replace(/-/g, "+").replace(/_/g, "/");
    if (!base64) return false;
    const payload = JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      )
    );
    if (payload?.exp && Date.now() >= payload.exp * 1000) return false;
    return true;
  } catch {
    return false;
  }
}

/**
 * AuthGate: blocks navigation to any route unless the user is authenticated.
 *   - Allows /signin (and other listed public paths) without a token.
 *   - Everything else redirects to /signin.
 * You can add more public paths in PUBLIC_PATHS if needed.
 */
function AuthGate() {
  const location = useLocation();

  // list of routes that are allowed without auth
  const PUBLIC_PATHS = ["/signin", "/register", "/forgot-password"];

  const isPublic = PUBLIC_PATHS.some((p) =>
    location.pathname.toLowerCase().startsWith(p)
  );

  if (!isPublic && !isTokenValid()) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  // render your app routes normally
  return (
    <>
      <AllRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

if (rootElement) {
  const root = createRoot(rootElement);

  const AppContent = (
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <AuthGate />
      </BrowserRouter>
    </Provider>
  );

  // render
  if (process.env.NODE_ENV === "development") {
    root.render(AppContent);
  } else {
    root.render(<React.StrictMode>{AppContent}</React.StrictMode>);
  }
} else {
  console.error("Element with id 'root' not found.");
}
